module.exports = __webpack_public_path__ + "img/icon-minus.d0891561.svg";